export const LOAD_ORDER_CONFIRMATION = 'orderConfirmation/LOAD_ORDER_CONFIRMATION';
export const RESET_ORDER_NUMBER = 'orderConfirmation/RESET_ORDER_NUMBER';
export const SET_ORDER_CONFIRMATION_STATUS = 'orderConfirmation/SET_ORDER_CONFIRMATION_STATUS';
export const SET_ORDER_NUMBER = 'orderConfirmation/SET_ORDER_NUMBER';
export const SET_SENT_ORDER_CONFIRMATION_STATUS = 'orderConfirmation/SET_SENT_ORDER_CONFIRMATION_STATUS';
export const SUBMIT_ORDER = 'orderConfirmation/SUBMIT_ORDER';
